import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import _get from 'lodash/get';

class Dropdown extends Component {

  constructor(props) {
    super(props);
    this.state = {listVisible: false};

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.hide);
  }

  hide() {
    this.setState({listVisible: false});
    document.removeEventListener("click", this.hide);
  }

  select(item) {
    this.props.setSelected(item)
  }

  show() {
    this.setState({listVisible: true});
    document.addEventListener("click", this.hide);
  }

  renderListItems() {
    let list = _get(this.props, 'list', []);
    return list.map((item) => {
      let rowClass = classNames({
        'px-4 py-2 block text-grey font-thin hover:bg-white hover:text-black hover:font-semibold': true,
      });
      return (
        <li onClick={this.select.bind(this, item)} key={item.name} className={rowClass}>{item.name}</li>
      )
    });
  }

  render() {
    const selectedName = _get(this.props, 'selectedName.name', '');
    const selectClasses = _get(this.props, 'selectClasses', '');
    const dropdownContainerClasses = this.props.dropdownContainerClasses || 'relative flex-grow md:max-w-xs md:mb-0 mb-2 outline-none';
    const selectedNameClasses = this.props.selectedNameClasses || '';
    const arrowIconClasses = classNames({
      'material-icons pin-r pin-y absolute pt-1 pb-2 text-grey-lighter': true,
    });

    const iconRow = this.props.iconRowClass || '';
    const optionClasses = _get(this.props, 'optionClasses', '');
    const listClasses = classNames(optionClasses, {
      'w-full break-words z-10 rounded absolute mt-8 pin-t pin-l cursor-pointer bg-white outline-none': true,
      'hidden': !_get(this.state, 'listVisible'),
    });

    const dropdownClasses = classNames(selectClasses, {
      'flex items-center w-full break-words pl-4 pr-6 py-2 hover:bg-grey-superlight cursor-pointer': true,
    });

    return (
      <div className={dropdownContainerClasses} onClick={this.show} tabIndex={0}>
        <div className={dropdownClasses}>
          <div className={selectedNameClasses}>{selectedName}</div>
          <div className={iconRow}>
              <i className={arrowIconClasses}>arrow_drop_down</i>
          </div>
        </div>
        <div className={listClasses}>
          <ul className="list-reset">
            {this.renderListItems()}
          </ul>
        </div>
      </div>)
  }
}

Dropdown.propTypes = {
  setSelected: PropTypes.func,
  list: PropTypes.array,
  selectedName: PropTypes.object,
  menuMobile: PropTypes.bool
};

export default Dropdown;


// WEBPACK FOOTER //
// ./src/containers/common/Dropdown.js